export default {
    setTechnicians(state, technicians) {
        state.appTechnicians = technicians;
    },
    setActiveTechnician(state, activeTechnician) {
        state.activeTech = activeTechnician;
    },
    setManageTechnicianDialog(state, status) {
        state.manageTechDialog = status;
    },
    setManageDeleteTechnicianDialog(state, status) {
        state.deleteTechDialog = status;
    }
}
